@if (showLoader) {
<div class="loading-bar">
  <div class="bar"></div>
  <div class="bar"></div>
  <div class="bar"></div>
  <div class="message">Loading Map Layers...</div>
</div>
}

<div #mapElement class="leaflet-touch"></div>